import * as React from 'react';
import { Header } from '../components/Header';
import { Container } from 'react-bootstrap';
import { Footer } from '../components/Footer';
import { Link, useLocation } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';

export default function ThankYou() {
    const location = useLocation();
    const formData = location.state.formData;
    const { t } = useTranslation();
    const facility = (formData.facility_number === '1') ? t('bnd_1') : t('bnd_2');
    return (
        <div className='page-fullscreen'>
            <Header />
            <div className='page-content blue-bg thank-page'>
                <Container>
                    <div className='thank-wrapper'>
                        <div className="vertical-center">
                            <div className='box'>
                                <div className='thanksBox rounded shadow'>
                                    <p>
                                        <Trans i18nKey="confirm_booking">
                                            {facility}
                                            {formData.day_part === '1' ? '07:30 - 09:30' : '13:00 - 15:00'}
                                            {formData.expect_date.toLocaleDateString('vi-VN')}
                                        </Trans>
                                    </p>
                                    <p>
                                        <Trans i18nKey="support_info">
                                            <Link to="tel:+842835352468"></Link>
                                            <Link to="tel:+84911072200"></Link>
                                        </Trans>
                                    </p>
                                </div>
                                <div className='infobox'>
                                    <a href="https://bernard.vn">
                                        <div className='info'>
                                            <img class="logo" src="/images/logo-bernard-white.svg" alt="" />
                                            <div>{t('bernard_website')}</div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
            <Footer />
        </div >
    );
}